import { useInfoSync } from '../Hooks/useInfoSync';

export const InfoSync = () => {
  useInfoSync();
  return null;
};
